import React from 'react'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'

export const formatAddress = ({ address1, city, state, zipCode }) =>
  `${address1} ${city}, ${state} ${zipCode}`

export const FormatAddress = (props) =>
  <EllipsisOption>{ formatAddress(props) }</EllipsisOption>

const EllipsisOption = styled.div`
  ${Mixin.ellipsis()}
`
